module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Missed-call-025006a63909e103b11747a5000a74a9.svg";